import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './views/CMS/vuex/store.js'
import ElementUI from 'element-ui'
import Antd from 'ant-design-vue'
import 'element-ui/lib/theme-chalk/index.css'
import 'ant-design-vue/dist/antd.css'

Vue.use(Antd)
Vue.use(ElementUI)
export var bus = new Vue()
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
